import {
    type IntakeStatus,
    IntakeStatusIndicator,
    StatusIndicator,
} from '@strata/react-status-indicators';

const REVIEW_NEEDED_STATUS = 'REVIEW_NEEDED';

interface IntakeStatusIndicatorProps {
    status?: IntakeStatus | typeof REVIEW_NEEDED_STATUS;
}

export const LighthouseIntakeStatusIndicator = ({
    status = undefined,
}: IntakeStatusIndicatorProps) =>
    status === REVIEW_NEEDED_STATUS ? (
        <StatusIndicator
            status={StatusIndicator.Status.WARNING}
            message="Review Needed"
            className="sds_indicator--intake-status"
        />
    ) : (
        <IntakeStatusIndicator status={status} useNewColors />
    );
